<!--<printheaderview [hasimage]="1">
</printheaderview>-->
<div class="">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Pickup Procedure</label>
              <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style3" [qrdata]="PatientID" [size]="90" [level]="'M'"></qrcode>-->

            </div>
            <!--<div class="col-print-1 padding-top-0px padding-bottom-0px"></div>-->
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style2" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>-->

          </div>
          <!--<div class="row">
    <div class="col-print-10 text-align-center">
      <label class="margin-bottom-0px margin-top-0px font-familyhead"></label>
    </div>
    <div class="col-print-2 padding-top-0px padding-bottom-0px">
      <qrcode class="padding-top-0px padding-bottom-0px qr-style" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>
    </div>
  </div>-->

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <!--<div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientID}}</label>
    </div>
  </div>-->
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-familysubhead font-weight-normal">Ovulation Trigger:</label>
                  </div>
                  <!--<div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{DocDate | date:'dd-MMM-yyyy'}})</label>
          </div>-->
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{triggertype}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-bold">Dose1</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{OvulationTriggerDate | date:'dd-MMM-yyyy'}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OvulationTriggerTime| slice:11}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Medicine:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{MedicineName}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Dose:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Dosage}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Expiry Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ExpiryDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="triggertype == 'Dual Trigger' || triggertype == 'Double Trigger'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-bold">Dose2</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="triggertype == 'Dual Trigger' || triggertype == 'Double Trigger'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OvulationTriggerDate2 | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="triggertype == 'Dual Trigger' || triggertype == 'Double Trigger'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Trigger Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OvulationTriggerTime2| slice:11}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="triggertype == 'Dual Trigger' || triggertype == 'Double Trigger'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Medicine:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{MedicineName2}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="triggertype == 'Dual Trigger' || triggertype == 'Double Trigger'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Dose:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Dosage2}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="triggertype == 'Dual Trigger' || triggertype == 'Double Trigger'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Expiry Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ExpiryDate2 | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>

              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-familysubhead font-weight-normal">Schedule:</label>
                  </div>
                  <!--<div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>-->
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Planned Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OvumPlannedPickupDate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Actual Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OvumPickupdate | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Actual Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OvumPickupTime | date:'hh:mm:ss'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-familysubhead font-weight-normal">Team:</label>
                  </div>
                  <!--<div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>-->
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Surgeon:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{SurgeonName}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">{{AsstSurgeon}}:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{AsstSurgeonName}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Anaesthesia:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{AnaesthesiaType}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Anaesthesiologist:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{AnesthesiologistName}}</label>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-familysubhead font-weight-normal">Procedure Details:</label>
                  </div>
                  <!--<div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{DocDate | date:'dd-MMM-yyyy'}})</label>
          </div>-->
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Needle Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{NeedleUsed}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Route:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Route}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Complications:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Complications}}</label>
                  </div>
                </div>

              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-familysubhead font-weight-normal">Endometrium:</label>
                  </div>
                  <!--<div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
          </div>-->
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Thickness:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal" *ngIf="EndometriumthicknessData">{{EndometriumthicknessData.EndometriumThickness}} {{EndometriumthicknessData.EndometriumThicknessUnits}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Count:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal" *ngIf="EndometriumthicknessData">{{EndometriumthicknessData.Count}}</label>
                  </div>
                </div>
                
                
              </div>
            </div>
          </div>




          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12 text-align-left">
                <label class="margin-bottom-0px font-familysubhead font-weight-normal">Follicle Size:</label>
              </div>
              <!--<div class="col-print-7" *ngIf="ScanDetail">
        <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ScanDetail.EndometriumThickness}} {{ScanDetail.EndometriumThicknessUnits}}</label>
      </div>-->
            </div>
          </div>
          <!--<div class="row margin-left-0px margin-right-0px">
      <div class="col-print-3">
        <label class="margin-bottom-0px font-family">Minimum Pickup Size:</label>
      </div>
      <div class="col-print-9">
        <label class="margin-bottom-0px font-family float-left">{{MinPickupSize}}</label>
      </div>
    </div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1">
                
              </div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px">
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          Right Ovary
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Left Ovary
                        </th>

                      </tr>
                      <tr>
                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          No. Of Follicles
                        </th>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RFollicleCount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{LFollicleCount}}</td>
                      </tr>
                      <tr>
                        <th class="font-weight-normal td-padding-tb background-primary font-family">
                          No. Of Follicles Aspirated
                        </th>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RFollicleAspirated}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{LFollicleAspirated}}</td>
                      </tr>
                      <tr>
                        <th class="font-weight-normal td-padding-tb background-primary font-family">
                          No. Of Follicles Retrieved
                        </th>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{TotalRtOocytes}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{TotalLtOocytes}}</td>
                      </tr>
                      <tr>
                        <th colspan="1" class="td-padding-tb background-primary font-family font-weight-normal">
                          Total No. Of Oocytes
                        </th>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{TotalOocytes}}</td>

                      </tr>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-3">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-8">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->
          
          <div class="col-print-12">
            <!--<div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>-->
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Tests:</label>
              </div>
              <div class="col-print-8">
                <!--<div class="row" *ngFor="let l of CurrentIvfCycleTestByCodeController">
        <div class="col-print-6 padding-left-15px">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.TestName}}</label>
        </div>
      </div>-->
              </div>
            </div>

            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1"></div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero tablepgbrk">
                      <tr class="trpgbrk">
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Test Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Result
                        </th>

                      </tr>
                      <tr class="trpgbrk" *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.TestName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Result}}{{l.ResultUnits}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>

            <!--<div class="row margin-left-0px margin-right-0px">
    <div class="col-print-3">
      <label class="margin-bottom-0px font-family font-weight-normal"></label>
    </div>
    <div class="col-print-8">
      <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
    </div>
  </div>-->
            <!--<div class="row margin-left-0px margin-right-0px">
    <div class="col-print-3">
      <label class="margin-bottom-0px font-family font-weight-normal">Result:</label>
    </div>
    <div class="col-print-8">
      <div class="row" *ngFor="let l of CurrentIvfCycleTestByCodeController">
        <div class="col-print-6 padding-left-15px">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Result}} {{l.ResultUnits}}</label>
        </div>
      </div>
    </div>
  </div>-->
            <!--<div class="row margin-left-0px">
    <div class="col-print-3">
      <label class="margin-bottom-0px font-family font-weight-normal"></label>
    </div>
    <div class="col-print-8">
      <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
    </div>
  </div>-->
            <!--<div class="pagebrkaft"></div>-->
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Medicines:</label>
              </div>
              <div class="col-print-8">
                <!--<div class="row" *ngFor="let l of CurrentIvfCycleMedicineByCodeController">
        <div class="col-print-6 padding-left-15px">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.MedicineName}}</label>
        </div>
      </div>-->

              </div>

            </div>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-1"></div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Medicine Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Dose
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.MedicineName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Dosage}} {{l.DurationType}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>


          </div>
          
          <!--<div class="pagebrk"></div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family">Doctor</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Assistant</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-7 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">{{SurgeonName}}</label>
                  </div>
                  <!--<div class="col-print-6">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>-->
                </div>
              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">{{AsstSurgeonName}}</label>
                  </div>
                  <!--<div class="col-print-5">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>-->
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview [Sign1]="Sign1" [Sign2]="Sign2"></printfooterview>-->
